export default __webpack_public_path__ + "static/media/bg.635ec811.webp";